<template>
  <!-- Bids are created in client panel showing opening, closing, amount, instructions, file to place html5 Ad (qualifier & saved), duration of ad. -->
  <div class="admin_category container">
    <v-card>
      <v-card-title>
        <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
        <v-divider class="mx-4" inset vertical></v-divider> 
        Bids
      </v-card-title>
      <v-data-table :headers="headers" :items="bids" :search="search" sort-by="slug" class="elevation-1">
        <template v-slot:top>
          <div class="hidden-md-and-up container">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          </div>
          <v-toolbar flat color="white">
            <div class="hidden-sm-and-down">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <router-link 
            :to="{ name: 'admin_subcategory_products', 
            params: { slug: item.slug }}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <b>{{ item.name }} +</b>
                </span>
              </template>
              <span>Make Dialog Showing Details</span>
            </v-tooltip>
          </router-link>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editBid(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deleteBid(item)"
            >
              mdi-delete
            </v-icon>SoftDel
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>Please Add A Bid</b></v-list-item-title>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import {db} from '@/firebase';
  
  export default {
    data: () => ({
      nav_title: 'Bids',
      dialog: false,
      status: [
        0,1
      ],
      priority: [
        0,1
      ],
      bid_code: [
        'ZMK',
        'ZIM'
      ],
      town_code: [
        'LSK'
      ],
      search: '',
      headers: [
        { text: 'Target', value: 'target' },// Main Page
        { text: 'Purpose', value: 'purpose' },// Advertising
        { text: 'Highest Bid', value: 'price' },
        { text: 'Due Week', value: 'week' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      bids: [],
      editedIndex: -1,
      bid: {
        name: '',
        slug: '',
        type: '',
        description: '',
        status: '',
        priority: '',
        movements: [],
        bid_code: [],
        town_code: []
      },
      activeItem: '',
      modal: ''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Bid' : 'Edit Bid'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    firestore() {
      return {
        bids: db.collection('bids')
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      
      updateBid(){
        this.$firestore.bids.doc(this.bid.id).update(this.bid)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Bid System updated successfully'
        })
        /* eslint-enable */
        this.close()
      },

      deleteBid(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestore.bids.doc(item.id).delete()            

            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
          }
        })
        /* eslint-enable */
      }, 

      close () {
        this.dialog = false
        setTimeout(() => {
          this.bid = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    },
  }
</script>
